import { render } from "./ViewClientPage.vue?vue&type=template&id=5484fc57&ts=true"
import script from "./ViewClientPage.vue?vue&type=script&lang=ts"
export * from "./ViewClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__